<template>
  <div class="schoolCardList-container div-layout">
    <module-title :title="detailData.name?detailData.name:''">
      <div style="padding-left:20px;float: left;">
        总授权码 <span class="bold font16">{{ equityFrom.totalCount }}</span>个     未核销码<span class="bold font16">{{ equityFrom.unuseCount }}</span>个  已核销码  <span class="bold font16">{{ equityFrom.usedCount }}</span>个  异常码<span class="bold font16">{{ equityFrom.failCount }}</span>个
      </div>
      <div class="right">
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-back"
          @click="$emit('update:visible', false)"
        >
          返回
        </el-button>
      </div>
    </module-title>
    <div class="schoolCardList-right-contain">
      <el-form
        ref="subjectSearchForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
        class="fl"
      >
        <el-form-item label="核销状态：" prop="status">
          <el-select
            v-model="searchForm.status"
            name="status"
            size="medium"
            class="edit-form-input"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="item in _selectionEquity"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="listLoading"
        :data="thirdaccountbalancesList"
        fit
        element-loading-text="Loading"
        class="list-table"
        highlight-current-row
      >
        <el-table-column type="index" width="55" align="center" label="序号" />
        <el-table-column label="注册码" align="center" prop="activeCode" />
        <el-table-column label="导入时间" prop="createDate" align="center" />
        <el-table-column label="核销状态" prop="status" align="center">
          <template slot-scope="scope">
            {{ scope.row.status===1?'未核销':scope.row.status===2?'已核销':'异常' }}
          </template>
        </el-table-column>
        <el-table-column label="核销时间" prop="updateDate" align="center">
          <template slot-scope="scope">
            {{ scope.row.status===1?'--':scope.row.updateDate }}
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>

import {
  getThirdaccountbalancesList,
  getEquityStatistic
} from '@/api/userManagement/index';
export default {
  name: 'ActorStudyManage',
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    detailData: {
      type: Object,
      default: function() {
        return { name: '' };
      }
    }
  },
  data() {
    return {
      thirdaccountbalancesList: [],
      equityFrom: {},
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        status: '',
        total: 0
      },
      listLoading: false
    };
  },
  computed: {
    // 核销状态：1：未核销 2：已核销 3：异常
    _selectionEquity() {
      return [{
        code: 1,
        name: '未核销'
      }, {
        code: 2,
        name: '已核销'
      }, {
        code: 3,
        name: '异常'
      }];
    }
  },
  mounted() {
    this.fetchThirdaccountbalancesList();
    this.featchEquityStatistic();
  },
  methods: {
    featchEquityStatistic() {
      getEquityStatistic().then(res => {
        if (res.data) {
          this.equityFrom = res.data;
        } else {
          this.thirdaccountbalancesList = [];
        }
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchThirdaccountbalancesList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchThirdaccountbalancesList();
    },

    // 获取列表名单
    fetchThirdaccountbalancesList() {
      var option = {
        ...this.searchForm
      };
      delete option.total;
      getThirdaccountbalancesList(option).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          var i = 0;
          res.data.list.map((item, index) => {
            if (item.status === '1') {
              i = index;
            }
            item.switchUpDown = true;
            return item;
          });
          res.data.list[i].switchUpDown = false;
          this.thirdaccountbalancesList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.thirdaccountbalancesList = [];
        }
      });
    },
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchThirdaccountbalancesList();
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
